import questionBank from '../data/mockExamV2.json';

const shuffle = (items) => {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

// Reserve two questions per reference topic so none disappears by chance.
const selectSection = (questions, count, topics) => {
  const reserved = topics.flatMap(topic => {
    const pool = questions.filter(q => q.referenceTopic === topic);
    if (pool.length < 2) throw new Error(`Mock exam V2 requires two ${topic} questions.`);
    return shuffle(pool).slice(0, 2);
  });
  const selectedIds = new Set(reserved.map(q => q.id));
  const remaining = questions.filter(q => !selectedIds.has(q.id));
  return shuffle([...reserved, ...shuffle(remaining).slice(0, count - reserved.length)]);
};

// Keep V2 independent of the original chapter and regulation question banks.
export const generateExamV2Questions = () => {
  const regulations = questionBank.filter(q => q.section === 'regulations');
  const technical = questionBank.filter(q => q.section === 'technical');
  if (regulations.length < 40 || technical.length < 60) {
    throw new Error('Mock exam V2 requires at least 40 regulations and 60 technical questions.');
  }

  return [...selectSection(regulations, 40, ['bands', 'qcodes', 'rst']),
    ...selectSection(technical, 60, ['resistors'])]
    .map((question, index) => {
      // Shuffle answer positions as well, preserving the answer key.
      const options = shuffle(question.options.map((text, originalIndex) => ({ text, originalIndex })));
      return {
        ...question,
        options: options.map(option => option.text),
        correct: options.findIndex(option => option.originalIndex === question.correct),
        examQuestionNumber: index + 1,
        examId: `v2-exam-${index + 1}`
      };
    });
};
